<section class="hvac-base-layout">
    <ng-content></ng-content>
</section>
